import forbes from '../images/rating/forbes_logo.svg'
import hh from '../images/rating/HH_logo.svg'
import PnM from '../images/rating/PnM_recruitment_logo.svg'
import PnMAdaptive from '../images/rating/PnM_adaptive.svg'
import DJ from '../images/rating/dreamjob_logo.svg'

export const rating = [
	{
		id: 1,
		title: 'Forbes',
		img: forbes,
		text: 'Серебряный работодатель по версии Forbes'
	},
	{
		id: 2,
		title: 'hh<br>Рейтинг работодателей',
		img: hh,
		text: 'В ТОП-200 Рейтинга работодателей России hh.ru (крупные компании)'
	},
	{
		id: 3,
		title: 'Pharma&Medical<br>Recruitment',
		img: PnM,
		text: 'Лауреат премии "Работодатель будущего 2024"'
	},
	{
		id: 4,
		title: 'оценка на Dream Job',
		img: DJ,
		text: '4,4 оценка на Dream Job'
	}
]

export const ratingAdaptive = [
	{
		id: 1,
		title: 'Forbes',
		img: forbes,
		text: 'Рейтинг лучших работодателей России Forbes'
	},
	{
		id: 2,
		title: 'hh<br>Рейтинг работодателей',
		img: hh,
		text: 'Рейтинг лучших работодателей России HeadHunter'
	},
	{
		id: 3,
		title: 'Pharma&Medical<br>Recruitment',
		img: PnMAdaptive,
		text: 'Премия «Работодатель будущего»'
	},
	{
		id: 4,
		title: 'оценка на Dream Job',
		img: DJ,
		text: '4,4 оценка на Dream Job'
	}
]
